module.exports = __webpack_public_path__ + "img/_gitd.8112abe1.jpg";